module.exports = __webpack_public_path__ + "img/3.9b55bed0.png";